import { Schema } from '@blade/std-lib'

export class TelegramResizePostMessage extends Schema.Class<TelegramResizePostMessage>(
  'TelegramResizePostMessage',
)({
  event: Schema.Literal('resize'),
  height: Schema.Number,
}) {
  static decode = Schema.decodeUnknownOption(
    Schema.fromJsonString(TelegramResizePostMessage),
  )
}
